var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLemag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2432 6.75676H9.75676C8.0999 6.75676 6.75676 8.09991 6.75676 9.75676V40.2432C6.75676 41.9001 8.09991 43.2432 9.75676 43.2432H40.2432C41.9001 43.2432 43.2432 41.9001 43.2432 40.2432V22.5946C43.2432 20.9377 44.5864 19.5946 46.2432 19.5946H47C48.6569 19.5946 50 20.9377 50 22.5946V42C50 46.4183 46.4183 50 42 50H8C3.58172 50 0 46.4183 0 42V8C0 3.58172 3.58172 0 8 0H42C46.4183 0 50 3.58172 50 8V10.5135C50 12.1704 48.6569 13.5135 47 13.5135H46.2432C44.5864 13.5135 43.2432 12.1704 43.2432 10.5135V9.75676C43.2432 8.0999 41.9001 6.75676 40.2432 6.75676Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 24.3243C12.1621 23.5779 12.7671 22.9729 13.5135 22.9729H36.4864C37.2328 22.9729 37.8378 23.5779 37.8378 24.3243C37.8378 25.0706 37.2328 25.6756 36.4864 25.6756H13.5135C12.7671 25.6756 12.1621 25.0706 12.1621 24.3243Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 31.081C12.1621 30.3347 12.7671 29.7297 13.5135 29.7297H36.4864C37.2328 29.7297 37.8378 30.3347 37.8378 31.081C37.8378 31.8274 37.2328 32.4324 36.4864 32.4324H13.5135C12.7671 32.4324 12.1621 31.8274 12.1621 31.081Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 37.8378C12.1621 37.0915 12.7671 36.4864 13.5135 36.4864H36.4864C37.2328 36.4864 37.8378 37.0915 37.8378 37.8378C37.8378 38.5841 37.2328 39.1891 36.4864 39.1891H13.5135C12.7671 39.1891 12.1621 38.5841 12.1621 37.8378Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1621 13.5135C12.1621 12.7671 12.7671 12.1621 13.5135 12.1621H36.4864C37.2328 12.1621 37.8378 12.7671 37.8378 13.5135V17.5675C37.8378 18.3138 37.2328 18.9189 36.4864 18.9189H13.5135C12.7671 18.9189 12.1621 18.3138 12.1621 17.5675V13.5135Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLemag);
export default __webpack_public_path__ + "static/media/ic_lemag.d261e82d798531ef47fbdfb4c80b46bf.svg";
export { ForwardRef as ReactComponent };